import styled from "styled-components";
import { InlineTextEdit } from "../../../CommonUI/InlineEditor/InlineTextEdit";
import { BaseFlowStepEditor } from "../../Steps/BaseFlowStepEditor";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";

export interface StepNameLabelProps {
    step: BaseFlowStepEditor;
}

export function StepNameLabel(props: StepNameLabelProps) {
    const name = props.step.name ?? "Step Name";
    return (
        <StempNameLabelRender className="StepNameLabel">
            {name}
            <InlineTextEdit
                text={name}
                onEdit={(val: string) => {
                    props.step.name = val;
                    props.step.stepUpdate();
                }}
            />
        </StempNameLabelRender>
    );
}

const StempNameLabelRender = styled.div`
    color: transparent;

    font-style: normal;
    font-size: 12px;
    line-height: 24px;
    position: relative;

    padding: 8px 16px;

    .InlineEdit {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
    }

    .InlineEdit-label {
        padding: 8px 16px;

        font-style: normal;
        font-size: 12px;
        line-height: 24px;
        max-width: 100%;
        border-bottom: none;
        display: flex;
        color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};

        &:hover {
            background: transparent;
            border-bottom: none;
        }
    }

    .InlineEdit-input {
        z-index: 5;
        background: ${UIStyleConstants.WHITE_COLOR};

        &.MuiInputBase-root {
            width: 100%;

            .MuiInputBase-input {
                border: none;
                border-bottom: 1px solid ${UIStyleConstants.GRAY_LIGHTER_COLOR};
                padding: 8px 16px;
                color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};

                font-style: normal;
                font-weight: 400;
                font-size: 12px;
                line-height: 24px;
                width: 100%;
            }
        }
    }
`;
